import { NextSeo } from 'next-seo';
import React from 'react';

import { Container, Typography } from '@seuk/design-system/atoms';
import { EmailAddress } from '@seuk/design-system/molecules';

import { Main as MainContainer } from '../../components';
import { FormPageTitle, FormSection } from '../../components/forms/forms';

const ConsultationThankYou = () => {
  return (
    <MainContainer>
      <NextSeo title="Request a consultation" noindex={true} nofollow={true} />
      <FormSection>
        <Container>
          <FormPageTitle>Request a consultation</FormPageTitle>
          <Typography variant="lead">
            A member of our energy solutions team will be in touch shortly. If you have any other questions, please
            email us at <EmailAddress email="SEUKL-contactus@shell.com" />.
          </Typography>
        </Container>
      </FormSection>
    </MainContainer>
  );
};

export default ConsultationThankYou;
